import { apiClient } from './index'

const basePath = `vadain-fabrics/filters/`

export default {
  async getFilters() {
    return await apiClient.get(basePath)
  }
}
